<template>
    <!-- form fields for the phone -->

    <div class="flex-column">
        <el-form-item
            prop="phone"
            :label="$t.__('common.labels.phone')"
            class="flex-column"
            :error="error ? error.tel : ''"
        >
            <vue-tel-input
                :data-bot="getDatabot('phone', currentStore)"
                placeholder="+33"
                v-model="phone"
                type="tel"
                class="span_6"
                :default-country="$store.state.corp.countryCode.toLowerCase()"
            />
        </el-form-item>

        <el-form-item
            prop="mobile"
            :label="$t.__('thirds.thirdscomponents.FormFieldsNumberPhone.mobile_phone')"
            class="flex-column"
            :error="error ? error.mobile : ''"
        >
            <vue-tel-input
                :data-bot="getDatabot('mobile', currentStore)"
                placeholder="+33"
                v-model="mobile"
                type="tel"
                class="span_6"
                :default-country="$store.state.corp.countryCode.toLowerCase()"
            />
        </el-form-item>

        <a
            v-if="!faxIsVisible"
            @click="faxIsVisible = !faxIsVisible"
            :data-bot="getDatabot('add-fax', currentStore)"
            class="mt-2 pointer fs-3 semibold hover-primary-100"
            >{{ $l10n.__('Ajouter un fax') }}</a
        >
        <el-form-item
            v-show="faxIsVisible"
            prop="fax"
            :label="$t.__('thirds.thirdscomponents.FormFieldsNumberPhone.fax')"
            class="flex-column"
            :error="error ? error.fax : ''"
        >
            <vue-tel-input
                :data-bot="getDatabot('fax', currentStore)"
                placeholder="+33"
                v-model="fax"
                type="tel"
                class="span_6"
                :default-country="$store.state.corp.countryCode.toLowerCase()"
            />
        </el-form-item>
    </div>
</template>

<script>
import VueTelInput from 'vue-tel-input';
import DataBotsFormsMixins from 'mixins/DataBotsFormsMixins';

export default {
    props: {
        currentStore: {
            type: String,
            required: true,
        },
        error: {
            type: [Object, Array],
            required: false,
        },
    },
    mixins: [DataBotsFormsMixins],
    components: {
        VueTelInput,
    },
    data() {
        return {
            faxIsVisible: false,
        };
    },

    computed: {
        phone: {
            get() {
                return this.$store.getters[`${this.currentStore}/getPhone`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setPhone`, value);
            },
        },
        mobile: {
            get() {
                return this.$store.getters[`${this.currentStore}/getMobile`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setMobile`, value);
            },
        },
        fax: {
            get() {
                return this.$store.getters[`${this.currentStore}/getFax`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setFax`, value);
            },
        },
    },
    methods: {
        getErrors(type) {
            return this.error.lenght > 0 ? this.error.get(type) : '';
        },
    },
};
</script>
